export default __webpack_public_path__ + "static/media/destination3.b694f22e.jpg";